import { render, staticRenderFns } from "./init-notice.vue?vue&type=template&id=11710222&scoped=true"
import script from "./init-notice.vue?vue&type=script&lang=js"
export * from "./init-notice.vue?vue&type=script&lang=js"
import style0 from "./init-notice.vue?vue&type=style&index=0&id=11710222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11710222",
  null
  
)

export default component.exports